<div class="meeting-scheduler">
    <div class="content">
      <!-- Step 1: Meeting Duration -->
      <div class="step">
        <h3>1. How long should each meeting be? </h3>
        <div class="duration-options">
          <button 
            *ngFor="let duration of durations" 
            [class.selected]="selectedDuration === duration.value"
            (click)="selectDuration(duration.value)">
            {{ duration.label }}
          </button>
        </div>
      </div>
  
      <!-- Step 2: Availability Period -->
      <div class="step">
        <h3>2. When is this availability active? </h3>
        <div class="date-range">
          <mat-form-field appearance="outline">
            <mat-label>From</mat-label>
            <input matInput [matDatepicker]="startPicker" [(ngModel)]="startDate" placeholder="Start date">
            <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
          </mat-form-field>
      
          <mat-form-field appearance="outline">
            <mat-label>Until</mat-label>
            <input matInput [matDatepicker]="endPicker" [(ngModel)]="endDate" placeholder="End date">
            <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
            <mat-datepicker #endPicker></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
      
  
      <!-- Step 3: Time Availability -->
      <div class="step">
        <h3>3. At which time are you available for meetings? </h3>
        
        <div class="days-grid">
          <div *ngFor="let day of daysOfWeek; let i = index" class="day-column">
            <div class="day-header">{{ day }}</div>
            
            <div class="time-slots">
              <div *ngFor="let slot of availability[i].timeSlots; let j = index" 
                   class="time-slot" 
                   [class.time-slot-invalid]="slot.isValid === false"
                   (click)="openTimeSlotEditor(i, j)">
                <div class="time-range">
                  <span>{{ slot.startTime }}</span>
                  <span class="time-separator">→</span>
                  <span>{{ slot.endTime }}</span>
                </div>
                <button class="remove-slot" (click)="removeTimeSlot(day, j); $event.stopPropagation();" *ngIf="availability[i].timeSlots.length > 0">×</button>
              </div>
              
              <button class="add-slot" (click)="addTimeSlot(day)">+</button>
            </div>
          </div>
        </div>
      </div>
  
      <!-- Buffer and Time Settings -->
      <div class="buffer-settings">
        <button class="toggle-buffer" (click)="toggleBufferSettings()">
          <span [class.expanded]="showBufferSettings">▼</span> BUFFER AND TIME SETTINGS
        </button>
        
        <!-- Time Format Toggle -->
        <!-- <div class="time-format-toggle">
          <label class="switch">
            <input type="checkbox" [checked]="timeFormat24h" (change)="toggleTimeFormat()">
            <span class="slider round"></span>
          </label>
          <span>{{ timeFormat24h ? '24-hour format' : '12-hour format' }}</span>
        </div> -->
        
        <div *ngIf="showBufferSettings" class="buffer-options">
          <div class="setting-row">
            <div class="setting">
              <label>Buffer time before event</label>
              <select [(ngModel)]="bufferTimeBefore">
                <option value="0">None</option>
                <option value="5">5 minutes</option>
                <option value="10">10 minutes</option>
                <option value="15">15 minutes</option>
                <option value="30">30 minutes</option>
                <option value="45">45 minutes</option>
                <option value="60">60 minutes</option>
              </select>
            </div>
            
            <div class="setting">
              <label>The shortest notice to book you</label>
              <select [(ngModel)]="shortestNotice">
                <option value="0">None</option>
                <option value="60">1 hour</option>
                <option value="120">2 hours</option>
                <option value="180">3 hours</option>
                <option value="240">4 hours</option>
                <option value="1440">1 day</option>
                <option value="2880">2 days</option>
                <option value="4320">3 days</option>
                <option value="10080">7 days</option>
              </select>
              
            </div>
          </div>
          
          <div class="setting-row">
            <div class="setting">
              <label>Buffer time after event</label>
              <select [(ngModel)]="bufferTimeAfter">
                <option value="0">None</option>
                <option value="5">5 minutes</option>
                <option value="10">10 minutes</option>
                <option value="15">15 minutes</option>
                <option value="30">30 minutes</option>
                <option value="45">45 minutes</option>
                <option value="60">60 minutes</option>
              </select>
            </div>
            
            <div class="setting">
              <label>How far in the future can someone book you?</label>
              <select [(ngModel)]="bookingFuturePeriod">
                <option value="7">1 week</option>
                <option value="14">2 weeks</option>
                <option value="30">1 month</option>
                <option value="90">3 months</option>
                <option value="180">6 months</option>
                <option value="365">1 year</option>
              </select>
            </div>
          </div>
          
          <div class="setting-row">
            <div class="setting">
              <label>The invitee is able to choose a time starting in every</label>
              <select [(ngModel)]="timeSlotIncrement">
                <option value="5">5 minutes</option>
                <option value="10">10 minutes</option>
                <option value="15">15 minutes</option>
                <option value="30">30 minutes</option>
                <option value="45">30 minutes</option>
                <option value="60">60 minutes</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Time Slot Editor Modal -->
    <!-- Time Slot Editor Modal (Updated) -->
<!-- Time Slot Editor Modal (Updated) -->
<!-- Time Slot Editor Modal -->
<!-- Time Slot Editor Modal -->
<div class="time-slot-editor-overlay" *ngIf="editingTimeSlot !== null">
  <div class="time-slot-editor" (click)="$event.stopPropagation()">
    <div class="editor-header">
      <h3>{{ isCreatingNewSlot ? 'Add Time Slot' : 'Edit Time Slot' }}</h3>
      <button class="close-button" (click)="closeTimeSlotEditor()">×</button>
    </div>
    
    <div class="editor-content">
      <div *ngIf="editingTimeSlot !== null">
        <p class="day-name">{{ availability[editingTimeSlot.dayIndex].day }}</p>
        
        <div class="time-inputs">
          <!-- Start Time Input -->
          <div class="input-group">
            <label>Start Time</label>
            <input 
              type="time" 
              [ngModel]="isCreatingNewSlot ? 
                (tempSlot.startTime ? convertToTimeInputFormat(tempSlot.startTime) : '') : 
                convertToTimeInputFormat(availability[editingTimeSlot.dayIndex].timeSlots[editingTimeSlot.slotIndex].startTime)"
              (ngModelChange)="onStartTimeChange($event)"
              #startTimeInput
              [class.invalid]="isCreatingNewSlot ? 
                !tempSlot.isValid : 
                !availability[editingTimeSlot.dayIndex].timeSlots[editingTimeSlot.slotIndex].isValid">
            <p class="time-display" *ngIf="isCreatingNewSlot ? tempSlot.startTime : availability[editingTimeSlot.dayIndex].timeSlots[editingTimeSlot.slotIndex].startTime">
              Display: {{ isCreatingNewSlot ? 
                tempSlot.startTime : 
                availability[editingTimeSlot.dayIndex].timeSlots[editingTimeSlot.slotIndex].startTime }}
            </p>
          </div>
          
          <!-- End Time Input -->
          <div class="input-group">
            <label>End Time</label>
            <input 
              type="time" 
              [ngModel]="isCreatingNewSlot ? 
                (tempSlot.endTime ? convertToTimeInputFormat(tempSlot.endTime) : '') : 
                convertToTimeInputFormat(availability[editingTimeSlot.dayIndex].timeSlots[editingTimeSlot.slotIndex].endTime)"
              (ngModelChange)="onEndTimeChange($event)"
              #endTimeInput
              [class.invalid]="isCreatingNewSlot ? 
                !tempSlot.isValid : 
                !availability[editingTimeSlot.dayIndex].timeSlots[editingTimeSlot.slotIndex].isValid">
            <p class="time-display" *ngIf="isCreatingNewSlot ? tempSlot.endTime : availability[editingTimeSlot.dayIndex].timeSlots[editingTimeSlot.slotIndex].endTime">
              Display: {{ isCreatingNewSlot ? 
                tempSlot.endTime : 
                availability[editingTimeSlot.dayIndex].timeSlots[editingTimeSlot.slotIndex].endTime }}
            </p>
          </div>
        </div>
        
        <!-- Error Message -->
        <p class="error-message" *ngIf="isCreatingNewSlot ? 
          !tempSlot.isValid : 
          !availability[editingTimeSlot.dayIndex].timeSlots[editingTimeSlot.slotIndex]?.isValid">
          {{ isCreatingNewSlot ? 
             tempSlot.errorMessage : 
             availability[editingTimeSlot.dayIndex].timeSlots[editingTimeSlot.slotIndex]?.errorMessage }}
        </p>
        
        <!-- Common Times -->
        <div class="common-times">
          <p>Common times:</p>
          <div class="time-buttons">
            <button (click)="setTimePresetWithConversion('9:00 AM', '5:00 PM')">9:00 AM - 5:00 PM</button>
            <button (click)="setTimePresetWithConversion('8:00 AM', '4:00 PM')">8:00 AM - 4:00 PM</button>
            <button (click)="setTimePresetWithConversion('10:00 AM', '6:00 PM')">10:00 AM - 6:00 PM</button>
          </div>
        </div>
      </div>
    </div>
    
    <div class="editor-footer">
      <button class="cancel-button" (click)="closeTimeSlotEditor()">Cancel</button>
      <button class="save-button" (click)="saveTimeSlot()">Save</button>
    </div>
  </div>
</div>
  
  </div>